import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core';
import { RadioInput } from '../FormElements';
import { CommandType } from '../../utils/types';
import { errorMsg } from '../SnackbarUtilsConfigurator';
import { CreateNewDialog } from '@terragotech/gen5-shared-components';
import { TextInputTG } from 'views/components/formElements';

interface Props {
  onSubmit: (result: { commandName: string; type: CommandType }) => void;
  onClose: () => void;
}

export const CreateNewCommandForm: React.FC<Props> = ({ onSubmit, onClose }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const [commandName, setCommandName] = useState<string | undefined>(undefined);
  const [type, setType] = useState<CommandType>('BUTTON');

  const handleOnSubmit = () => {
    if (!commandName) return errorMsg('Command name is required');
    onSubmit({ commandName, type });
  };

  return (
    <CreateNewDialog title={'Create new command'} onClose={onClose} onSubmit={handleOnSubmit}>
      <TextInputTG
        id="commandName"
        label="Command Name"
        value={commandName}
        onChange={(value) => setCommandName(value)}
        labelRoot={classes.label}
      />
      <RadioInput
        title="Command Type"
        value={type}
        onChange={(value) => setType(value as 'FORM' | 'BUTTON' | 'IMPORT' | 'TIMER' | 'ZEBRA')}
        options={commandTypeOptions}
        containerStyle={styles.radioContainer}
        labelStyle={classes.label}
        radioButtonStyle={classes.radioButton}
      />
    </CreateNewDialog>
  );
};

const commandTypeOptions = [
  { value: 'BUTTON', label: 'Button' },
  { value: 'FORM', label: 'Form' },
  { value: 'IMPORT', label: 'Import' },
  { value: 'TIMER', label: 'Timer' },
  { value: 'ZEBRA', label: 'Zebra Print' },
];

const styles = {
  radioContainer: {
    marginTop: 23,
  },
};

const useStyles = makeStyles({
  label: (props: { theme: any }) => ({
    fontSize: '15px !important',
    fontWeight: 500,
    lineHeight: '100%',
    color: props.theme.palette.text.primary,
  }),
  radioButton: (props: { theme: any }) => ({
    width: 24,
    height: 24,
    margin: '6px 9px',
    '& + .MuiTypography-root': {
      fontSize: '14px !important',
      fontWeight: 400,
      color: props.theme.palette.text.primary,
    },
  }),
});
